// Module
var code = "<techniques></techniques>\n";
// Exports
module.exports = code;